import Tooltip from 'rc-tooltip'
import type { ReactElement } from 'react'
import React, { forwardRef } from 'react'

import DragHandle from './DragHandle'
import styles from './DragHandlePopover.module.css'

type Props = {
  hide?: boolean
  children: ReactElement
}

const DragHandlePopover = forwardRef<HTMLDivElement, Props>(
  ({ hide, children }, ref) => {
    return (
      <Tooltip
        {...(hide && { visible: false })}
        placement='left'
        overlayClassName={styles.Overlay}
        showArrow={false}
        overlay={<DragHandle ref={ref} />}
      >
        <div>{children}</div>
      </Tooltip>
    )
  }
)
DragHandlePopover.displayName = 'DragHandlePopover'

export default DragHandlePopover
